import moment from 'moment'
import React,{useState,useEffect,useRef, useCallback} from 'react'
import { Attendance,FR } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { assetUrl } from '../../helpers'
import { toasterFunction } from '../Default/ToasterComponent'
export const DateWiseSearch = () => {
  const [state, setState] = useState({ 
  loader: true, 
  date: moment().format("yyyy-MM-DD"),
  rawData:[], 
  tableLoader: true,
  tbHeader:[{title:"Date",name:"Date"},{title:"Time",name:"time"},{title:"Camera ID",name:"Camera ID"},{title:"Employee ID",name:"Employee ID"},{title:"Name",name:"name"},{title:"Type",name:"type"},{title:"confidence",name:"confidence"},{title:"Image",name:"image"},{title:"Operations",name:"details"}],
  tbHeader2:[],
  data:[],
  data2:[],
  selectedData:{},
  selectEmployee:"",
  selectIndex:"",
  selectId:"",
  preSelectedEmployee:"",
  formAttr:{
    employee_id:"",
    check_in:"",
    date:"",
    type:"checkin",
  },
  loader2:false
});
  const ref3=useRef();
  const ref4=useRef({
    selectId:"",
    selectIndex:"",
    selectEmployee:"",
    preSelectedEmployee:"",
    data:[]
  })
const apiData = async () => {
    try {
      setState((pre)=>{
      return {...pre,loader:true,tableLoader: true}
      })
      let data = {date:state.date}
      let result = await new Attendance().missingPeopleList(data);
      let arr=[];
      let count=0;
      if(result.length){
      for(let val of result){
       const maxObject = val.recognitions.reduce((max, obj) => obj.confidence > max.confidence ? obj : max, val.recognitions[0]);
       arr.push([val.date,moment.unix(Number(val.time)/1000).format("HH:mm:ss"),val.camera_id,maxObject?.employee_id?maxObject.employee_id:"",maxObject?.employee_name?maxObject.employee_name:"",val.type?val.type:"",maxObject?.confidence?Number(maxObject.confidence).toFixed(2):"",val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img  src=${assetUrl}${val.image} style="max-width:100px;max-height:100px" />`:"",`<button type="button" data-emloyeeId=${val._id} data-index=${count} class="btn btn-theme details">Details</button> <button type="button"  data-emloyeeId=${maxObject?.employee_id?maxObject.employee_id:""} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`])
       count++;
      }
    }
   ref4.current.data=arr
      setState((pre) => {
        return { ...pre, data: arr, loader: false, tableLoader: false,rawData:result }
      })
    } catch (e) {
      console.log(e)
      alert("error occur")
    }

  }
const onSubmitAdd=async (event)=>{
  event.preventDefault();
  ref3.current.disabled=true;
  ref3.current.firstElementChild.style.display="inline-block"
 try{
 await new Attendance().addMannual(state.formAttr);
 toasterFunction.success("attendance has been added");
 window.location.reload(); 
 }catch(e){
  
 if(e.response.status===300){
  toasterFunction.error("Employee already taken")
 }else if(e.response.status===404){
  toasterFunction.error("check in not found")
 }
 else{
  Object.values(e.response.data)[0].forEach(val=>{
    toasterFunction.error(val)
  })
}
ref3.current.disabled=false;
ref3.current.firstElementChild.style.display="none"
}
}
const onHandlerForm=(event)=>{
  let key=event.target.name;
  let value=event.target.value;
  console.log(key,value)
  let oldState={...state}
  oldState.formAttr[key]=value;
  setState((pre)=>{
    return {...pre,...oldState}
  })
  
}
const onSelectInput=useCallback((event)=>{
  let selectEmployee=event.target.value;
  let id=event.target.getAttribute('data-id');
  ref4.current={...ref4.current,selectEmployee,selectId:id}
  setState((pre)=>{
    return {...pre,selectEmployee,selectId:id}
  })},[])
  

const onHandler = (event) => {
    let date = null;
    if(event.target.name == "date"){
      date = moment(event.target.value).format("yyyy-MM-DD");
      setState((pre)=>{
        return {...pre,[event.target.name]:date}
          })
    }else{
      setState((pre)=>{
        return {...pre,[event.target.name]:Number(event.target.value)}
          })
    }
      
    // apiData(moment(month).format("yyyy-MM-DD"))
    
    console.log(state);
  }
const onDetails=(id,selectIndex)=>{
    let check=state.rawData.find(val=>val._id===id);
    
    if(check){
      const maxObject = check.recognitions.reduce((max, obj) => obj.confidence > max.confidence ? obj : max, check.recognitions[0]);
      let selectEmployee=maxObject?.employee_id;
      let preSelectedEmployee=ref4.current.preSelectedEmployee;
      
      if(ref4.current.selectEmployee !== "" && (id ===ref4.current.selectId && selectEmployee !== preSelectedEmployee)){
        selectEmployee=ref4.current.preSelectedEmployee;
      }
      let selectId=id;
      ref4.current={...ref4.current,selectEmployee,preSelectedEmployee,selectId,selectIndex}
      setState((pre)=>{
        return {...pre,selectedData:check,selectEmployee,preSelectedEmployee,selectIndex,selectId}
      })
      window.$("#showImg").modal("show");
    }
    else{
      alert("data not found")
    }
    
    // apiData2(employeeId);
   
   
  }
const onSelect=()=>{
  let val=state.rawData.find(val=>val._id===ref4.current.selectId);
  if(val){
   let maxObject=val.recognitions.find(val2=>val2.employee_id===ref4.current.selectEmployee);
   state.data[Number(ref4.current.selectIndex)]=[val.date,moment.unix(val.time/1000).format("HH:mm:ss"),maxObject?.employee_name?maxObject.employee_name:"",maxObject?.employee_id?maxObject.employee_id:"",val.type?val.type:"",maxObject?.confidence?maxObject.confidence:"",val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img src=${assetUrl}${val.image} style="width:100%;height:140px" />`:"",`<button type="button" data-emloyeeId=${val._id} data-index=${ref4.current.selectIndex} class="btn btn-theme details">Details</button> <button type="button" data-emloyeeId=${maxObject?.employee_id?maxObject.employee_id:""} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`];
   ref4.current.data[Number(ref4.current.selectIndex)]=[val.date,moment.unix(val.time/1000).format("HH:mm:ss"),maxObject?.employee_name?maxObject.employee_name:"",maxObject?.employee_id?maxObject.employee_id:"",val.type?val.type:"",maxObject?.confidence?maxObject.confidence:"",val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img src=${assetUrl}${val.image} style="width:100%;height:140px" />`:"",`<button type="button" data-emloyeeId=${val._id} data-index=${ref4.current.selectIndex} class="btn btn-theme details">Details</button> <button type="button" data-emloyeeId=${maxObject?.employee_id?maxObject.employee_id:""} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`] 
  }
  
  let preSelectedEmployee=ref4.current.selectEmployee;
  ref4.current={...ref4.current,preSelectedEmployee}
  setState((pre)=>{
    return {...pre,...state,preSelectedEmployee}
  })
  window.$("#showImg").modal("hide");
  }
const onSelectSubmit=async (id,employeeId)=>{
  console.log("here")
  try{
   if(window.confirm("are you want to mark this attendance ? Please Make sure, beacuse this attendance can not be undo")){
    await new Attendance().markAttendance({id,employeeId:String(employeeId)});
    toasterFunction.success("attendance has been mark");
    window.location.reload(); 
   } 

  }catch(e){
if(e.response.status===404){
  toasterFunction.error("check in not found")
}
else{
  toasterFunction.error("something went wrong");
}
 
  }
  }
useEffect(() => {
    apiData();
    setState((pre) => {
      return { ...pre}
    })
  }, [])

    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div className="d-flex fw-bold small mb-3">
              <div className='row' style={{width:"100%"}}>
              <div className="col-sm-12 col-md-8">
                <span className="flex-grow-1">Missing People Report</span>
              </div>
              {/* <div className="col-5 d-flex" style={{justifyContent:"center",alignItems:"center",}}>
              <button type="button" class="btn btn-theme" onClick={()=>{
                window.$("#showForm").modal("show")
              }}>Add Attendance</button>
              </div> */}
              <div className="col sm-6 col-md-2">
                {/* <button type="button" class="btn btn-theme" onClick={exportCsv}>Export Csv</button> */}
                <div class="form-group mb-3" style={{ width: "85%" }}>
                  <label class="form-label" for="exampleFormControlSelect1">Select Date</label>
                  <input type="date" class="form-control text-white" id='date' format="yyyy-MM-DD" name='date' value={state.date} placeholder="yyyy-MM-DD" onChange={onHandler}/>
                </div>
              </div>
             
              <div className='col sm-6 col-md-2'>
                <label class="form-label" for="Location">Submit</label>
                <br />
                <button type="button" class="btn btn-theme" onClick={apiData}>Search</button>
              </div>
              </div>
            </div>

            {state.loader && <><Loader/></>}
   {!state.loader && <>
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={ref4.current.data} image={true} updated={state.updated} onDetails={onDetails} onSelectSubmit={onSelectSubmit}  reverse={true}/>
  
   </div>
   </>}
  
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Attendance</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employee_id'
              value={state.formAttr.employee_id}
              onChange={onHandlerForm}
              required
            />
          </div>
          </div>
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label class="form-label" for="exampleFormControlSelect1">Date</label>
                  <input type="date" class="form-control text-white" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandlerForm} value={state.formAttr.date}/>
          </div>
          </div>
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Time
            </label>
            <input
              type="time"
              className="form-control"
              placeholder="Enter Time"
              name='check_in'
              value={state.formAttr.check_in}
              onChange={onHandlerForm}
              required
            />
          </div>
          </div>
          <div className="col-xl-6" style={{paddingTop: "5px"}}>
   <div className="text-white text-opacity-50 mb-1">
    <b>Type</b>
  </div>
  <div className="form-group mb-4">
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="type"
        id="defaultRadio1"
        value="checkin"
        onChange={onHandlerForm}
        checked={state.formAttr.type==="checkin"}
        required

      />
      <label className="form-check-label" htmlFor="defaultRadio1">
        Check in
      </label>
    </div>
    <div className="form-check form-check-inline">
    <input
        className="form-check-input"
        type="radio"
        name="type"
        id="defaultRadio2"
        value="checkout"
        onChange={onHandlerForm}
        checked={state.formAttr.type==="checkout"}
        required

      />
      <label className="form-check-label" htmlFor="defaultRadio2">
        Check Out
      </label>
    </div>
   
  </div>
</div>

         
     
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="button" class="btn btn-outline-theme w-25" ref={ref3} disabled={false}>Select</button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
  
  <div class="modal-body">
    <div>
        <h5>Actual Information</h5>     
  <table className="table">
    <thead>
      <tr>
       
       <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col">Image</th>
      </tr>
    </thead>
    <tbody>
      <tr>
       
        <td style={{width:"25%"}}>{state.selectedData.date}</td>
        <td style={{width:"25%"}}>{moment.unix(state.selectedData.time/1000).format("HH:mm:ss")}</td>
        <td style={{width:"25%"}}>
      {state.selectedData.image ? (
        <>
          <div style={{ display: 'none' }}>{`${assetUrl}${state.selectedData.image}`}</div>
          <img src={`${assetUrl}${state.selectedData.image}`} style={{ width: '50%', height: '100px' }} alt="Selected" />
        </>
      ) : (
        ""
      )}
    </td>
      </tr>
    </tbody>
  </table>

  </div>
  <hr/>
  <div>
  <h5>Employees with confidence</h5>     
  <table className="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">Employee Id</th>
        <th scope="col">Department</th>
        <th scope="col">Confidence</th>
        <th scope="col">Image</th>
      </tr>
    </thead>
    <tbody>
     {state.selectedData?.peoples?.map((val,index)=>{
      let {confidence}=state.selectedData.recognitions.find(val2=>val2.employee_id ===val.employeeId);
      
      return (<>
       <tr>
        <th scope="row"><div className="form-check">
  <input
    className="form-check-input"
    type="radio"
    value={val.employeeId}
    id={`defaultRadio${val.employeeId}`}
    onChange={onSelectInput}
    data-id={state.selectedData?._id}
    checked={val.employeeId===state.selectEmployee}
  />
  <label className="form-check-label" htmlFor={`defaultRadio${index}`} style={{display:"none"}}>
    Default checkbox
  </label>
</div></th>
        <td>{`${val.firstName} ${val.middleName} ${val.lastName}`}</td>
        <td>{val.employeeId}</td>
        <td>{val.departmentName}</td>
        <td>{Number(confidence).toFixed(2)}</td>
        <td>{val.frontImageUrl ? (
        <>
          <div style={{ display: 'none' }}>{`${assetUrl}${val.frontImageUrl}`}</div>
          <img src={`${assetUrl}${val.frontImageUrl}`} style={{ width: '50%', height: '100px' }} alt="Selected" />
        </>
      ) : (
        ""
      )}</td>
      </tr>
      
      </>)
     })}
     
     
    </tbody>
  </table>

  </div>
              </div>
              <div className="modal-footer">
  <button type="button" className="btn btn-default" data-bs-dismiss="modal">
    Close
  </button>
  <button type="button" className="btn btn-outline-theme" onClick={onSelect}>
    Select
  </button>
</div>
            </div>
          </div>
        </div>


      </>


    )
 

}
